import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import {CircularProgress} from '@material-ui/core';
import 'Agent/Accounts/components/A360EnrollmentApplication/EnrollmentApplicationModal.sass';
import {
  EnrollmentApplication,
  EnrollmentApplicationWithError,
  EnrollmentApplicationWithDuplicateUploadError,
  InvalidEnrollmentApplication,
  matchEnrollmentApplication,
  ValidEnrollmentApplication,
} from 'Agent/Accounts/models/A360EnrollmentApplication';
import Modal from 'Shared/components/Modal';
import A360EnrollmentApplicationForm from './A360EnrollmentApplicationForm';
import {isLoaded} from 'Core/models/Async';
import {CustomerConnectionProfile, clearApplication} from 'Agent/Accounts/ducks/a360EnrollmentApplication';

type A360EnrollmentApplicationModalProps = {
  accountNumber: string;
  accountName: string;
  hideModal: () => void;
};

export const A360EnrollmentApplicationModal = (props: A360EnrollmentApplicationModalProps) => {
  const dispatch = useDispatch();
  const {application, customerConnectionProfile} = useSelector((state: ReducerState) => state.a360EnrollmentApplication);
  const resetApplication = () => {
    dispatch(clearApplication());
  };
  useEffect(() => resetApplication, []);
  const custConProfiles: CustomerConnectionProfile[] = isLoaded(customerConnectionProfile) && customerConnectionProfile?.Data?.length > 0
    ? customerConnectionProfile.Data : [];

  const renderApplicationForm = (
    application: EnrollmentApplication
  ) => (
    <A360EnrollmentApplicationForm
      application={application}
      accountNumber={props.accountNumber}
      accountName={props.accountName}
      customerConnectionProfile={custConProfiles}
      onCancel={props.hideModal}
    />
  );

  return (
    <Modal title="Upload Enrollment Application" open onClose={props.hideModal} disableBackdropClick>
      {matchEnrollmentApplication(application, {
        EnrollmentApplicationWithError: renderApplicationForm,
        EnrollmentApplicationWithDuplicateUploadError: renderApplicationForm,
        InvalidEnrollmentApplication: renderApplicationForm,
        ValidEnrollmentApplication: renderApplicationForm,
        SavingEnrollmentApplication: () => (
          <div className="upload-a360-enrollment-application__loading-container">
            <CircularProgress />
          </div>
        ),
      })}
    </Modal>
  );
};

export default A360EnrollmentApplicationModal;
